import { initialState } from "./initialState";
import {
  API_FILE_URL_STATUS,
  API_STATUS,
  GET_FILE_URL,
  GET_FOLDERS_AND_FILES,
  GET_PENDING_BATCHES_LIST,
} from "./types";

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case API_STATUS:
      return {
        ...state,
        apiStatus: action.payload,
      };

    // case CLEAR_API_STATUS:
    //   return {
    //     ...state,
    //     apiStatus: initialState,
    //   };

    case API_FILE_URL_STATUS:
      return {
        ...state,
        apiFileUrlStatus: action.payload,
      };

    case GET_FOLDERS_AND_FILES:
      return {
        ...state,
        foldersAndFIles: action.payload,
      };

    case GET_FILE_URL:
      return {
        ...state,
        fileUrl: action.payload,
      };

    case GET_PENDING_BATCHES_LIST:
      return {
        ...state,
        pendinBatchesList: action.payload,
      };

    default:
      return state;
  }
};

export default reducer;
